export enum InvoicingMethod {
  PER_MONTH = 'PER_MONTH',
  PER_COLLECTION = 'PER_COLLECTION',
}
